export default __webpack_public_path__ + "static/media/cheque.fff6378f.png";